import apiEndpoints from 'api/endpoints';
import { DEFAULT_WORKFLOW_PAGE_SIZE } from 'views/V2/Medallion/Workflow/constants';

import { baseAPI } from './baseApi';
import { globalAPI } from './globalApi';

// Themes live on baseAPI, so tags set here can't reach them. Workflow changes
// move theme usage, so refresh the themes list by hand once the change lands.
const refreshThemeUsage = async (arg, { dispatch, queryFulfilled }) => {
    try {
        await queryFulfilled;
        dispatch(baseAPI.util.invalidateTags(['Themes']));
    } catch {
        // A failed change leaves theme usage as it was.
    }
};

//note: manage it better by creating one base api
export const workflowApi = globalAPI.injectEndpoints({
    endpoints: (builder) => ({
        fetchAllWorkflows: builder.query({
            query: (page = 0, size = DEFAULT_WORKFLOW_PAGE_SIZE) => ({
                url: `${apiEndpoints.workflowUrl}?pageNumber=${page}&pageSize=${size}`,
                method: 'GET',
            }),
            providesTags: ['workflow'],
        }),
        createWorkflow: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.workflowUrl}`,
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: (result, error) => (error ? [] : ['workflow']),
            onQueryStarted: refreshThemeUsage,
        }),
        makeWorkflowDefault: builder.mutation({
            query: ({ workflowId }) => ({
                url: `${apiEndpoints.workflowUrl}/${workflowId}/default`,
                method: 'PUT',
            }),
            invalidatesTags: (result, error) => (error ? [] : ['workflow']),
        }),
        deleteWorkflow: builder.mutation({
            query: ({ workflowId }) => ({
                url: `${apiEndpoints.workflowUrl}/${workflowId}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error) => (error ? [] : ['workflow']),
            onQueryStarted: refreshThemeUsage,
        }),
        fetchSingleWorkflow: builder.query({
            query: (nanoid) => ({
                url: `${apiEndpoints.workflowUrl}/${nanoid}`,
                method: 'GET',
            }),
        }),
        editWorkflow: builder.mutation({
            query: ({ nanoid, data }) => ({
                url: `${apiEndpoints.workflowUrl}/${nanoid}`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: (result, error) => (error ? [] : ['workflow']),
            onQueryStarted: refreshThemeUsage,
        }),
    }),
});

export const {
    useFetchAllWorkflowsQuery,
    useLazyFetchAllWorkflowsQuery: useFetchAllWorkflows,
    useCreateWorkflowMutation,
    useMakeWorkflowDefaultMutation,
    useDeleteWorkflowMutation,
    useFetchSingleWorkflowQuery,
    useLazyFetchSingleWorkflowQuery,
    useEditWorkflowMutation,
} = workflowApi;

export default workflowApi.middleware;
